import Vue from "vue";
import Router from "vue-router";
import { Toast } from "vant";
import {
  hasToken,
  redirectToAuth,
  isWechatBrowser,
  getCodeFromUrl,
  getContentFromState,
  exchangeToken,
  setToken,
} from "@/utils/wechatAuth";
import { setStorage } from "@/utils/storage";

Vue.use(Router);

const routes = [
  // {
  //   path: "/",
  //   redirect: "/mine/userInfo",
  // },
  {
    path: "/mine/userInfo",
    name: "首页",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/guide",
    name: "引导页",
    component: () => import("@/views/Guide.vue"),
  },
  {
    path: "/projectSquare",
    name: "我的项目",
    component: () => import("@/views/projectSquare.vue"),
  },
  {
    path: "/projectSquare/detail",
    name: "项目详情",
    component: () => import("@/views/projectSquare.vue"),
  },
  {
    path: "/settlement",
    name: "结算记录",
    component: () => import("@/views/settlement.vue"),
  },
  {
    path: "/settlement/detail",
    name: "结算详情",
    component: () => import("@/views/settlementDetail.vue"),
  },
  {
    path: "/square",
    name: "任务大厅",
    component: () => import("@/views/square.vue"),
  },
  {
    path: "/square/detail",
    name: "任务详情",
    component: () => import("@/views/squareDetail.vue"),
  },
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const entryContent = (to.query && to.query.content) || "";
  if (entryContent) {
    setStorage("wechat_content", entryContent);
  }

  // 非微信访问签约页时进入引导页，其它原有逻辑不变
  if (!isWechatBrowser() && to.path === "/mine/userInfo") {
    next({
      path: "/guide",
      query: to.query,
      replace: true,
    });
    return;
  }
  if (isWechatBrowser() && to.path === "/guide") {
    next({
      path: "/mine/userInfo",
      query: to.query,
      replace: true,
    });
    return;
  }

  // 1. 有 token -> 直接放行
  if (hasToken()) {
    next();
    return;
  }

  // 2. 获取 content（优先 URL content 参数，其次 state 参数）
  const urlParams = new URLSearchParams(window.location.search);
  const urlContent = urlParams.get("content") || "";
  const stateContent = getContentFromState();
  const content = urlContent || stateContent;

  // 3. 检查是否有 code（微信授权回调后带回来的）
  const code = getCodeFromUrl();

  if (code) {
    // 有 code，换取 token（带超时保护，防止卡死）
    Toast.loading("授权中...", 0);

    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error("timeout")), 8000);
    });

    Promise.race([exchangeToken(code), timeoutPromise])
      .then((res) => {
        Toast.clear();

        if (res.code === "0000" && res.data && res.data.token) {
          setToken(res.data.token);
          Toast.success("授权成功");
        } else {
          Toast.fail(res.message || "授权失败");
        }
        // 只清除 code（只能用一次），保留 state（content 在 state 中）
        cleanUrlParams(["code"]);
        next();
      })
      .catch(() => {
        Toast.clear();
        Toast.fail("授权超时，请刷新页面重试");
        cleanUrlParams(["code"]);
        next();
      });
  } else {
    // 没有 code，跳转微信授权获取 code
    if (isWechatBrowser()) {
      redirectToAuth(content);
    } else {
      next();
    }
  }
});

/**
 * 清除 URL 中的指定参数（code 只能用一次，用完必须清除）
 */
function cleanUrlParams(paramsToRemove) {
  try {
    const url = new URL(window.location.href);
    paramsToRemove.forEach((param) => url.searchParams.delete(param));
    window.history.replaceState({}, "", url.toString());
  } catch (e) {
    // ignore
  }
}

export default router;
